module.exports = __webpack_public_path__ + "img/modal_image.59957760.png";